document.addEventListener('DOMContentLoaded', () => {
    // User menu dropdown functionality (works independently)
    const userDropdownButton = document.querySelector('.dashboard-page__sidebar__user-dropdown');
    const userMenu = document.querySelector('.dashboard-page__sidebar__user-menu');
    const userWrapper = document.querySelector('.dashboard-page__sidebar__user-wrapper');

    if (userDropdownButton && userMenu && userWrapper) {
        // Toggle menu on button click
        userDropdownButton.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            const isOpen = userMenu.classList.contains('dashboard-page__sidebar__user-menu--active');
            
            if (isOpen) {
                // Close menu
                userMenu.classList.remove('dashboard-page__sidebar__user-menu--active');
                userDropdownButton.classList.remove('dashboard-page__sidebar__user-dropdown--active');
                userWrapper.classList.remove('dashboard-page__sidebar__user-wrapper--menu-open');
                userDropdownButton.setAttribute('aria-expanded', 'false');
            } else {
                // Open menu
                userMenu.classList.add('dashboard-page__sidebar__user-menu--active');
                userDropdownButton.classList.add('dashboard-page__sidebar__user-dropdown--active');
                userWrapper.classList.add('dashboard-page__sidebar__user-wrapper--menu-open');
                userDropdownButton.setAttribute('aria-expanded', 'true');
            }
        });

        // Close menu when clicking outside
        document.addEventListener('click', (e) => {
            if (!userWrapper.contains(e.target)) {
                userMenu.classList.remove('dashboard-page__sidebar__user-menu--active');
                userDropdownButton.classList.remove('dashboard-page__sidebar__user-dropdown--active');
                userWrapper.classList.remove('dashboard-page__sidebar__user-wrapper--menu-open');
                userDropdownButton.setAttribute('aria-expanded', 'false');
            }
        });

        // Prevent menu from closing when clicking inside it
        userMenu.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    }

    const ANALYTICS_SUBMENU_STORAGE_KEY = 'dashboard-analytics-submenu-open';

    document.querySelectorAll('[data-kad-analytics-block]').forEach((block) => {
        const toggle = block.querySelector('[data-kad-analytics-toggle]');
        const submenu = block.querySelector('.dashboard-page__sidebar__analytics-submenu');
        const link = block.querySelector('.dashboard-page__sidebar__analytics-link');

        if (!toggle || !submenu) {
            return;
        }

        const setOpen = (isOpen) => {
            block.classList.toggle('dashboard-page__sidebar__analytics--open', isOpen);
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            toggle.setAttribute(
                'aria-label',
                isOpen ? 'Згорнути підменю аналітики' : 'Розгорнути підменю аналітики'
            );
        };

        const saved = localStorage.getItem(ANALYTICS_SUBMENU_STORAGE_KEY);
        const defaultOpen = block.dataset.defaultOpen === '1';
        const isOpen = saved !== null ? saved === 'true' : defaultOpen;

        setOpen(isOpen);

        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const nextOpen = !block.classList.contains('dashboard-page__sidebar__analytics--open');
            setOpen(nextOpen);
            localStorage.setItem(ANALYTICS_SUBMENU_STORAGE_KEY, nextOpen ? 'true' : 'false');
        });

        if (link) {
            link.addEventListener('click', () => {
                if (!block.classList.contains('dashboard-page__sidebar__analytics--open')) {
                    setOpen(true);
                    localStorage.setItem(ANALYTICS_SUBMENU_STORAGE_KEY, 'true');
                }
            });
        }
    });

    const dashboardPage = document.getElementById('dashboard-page');
    const sidebar = document.getElementById('dashboard-sidebar');
    const toggleButton = document.getElementById('dashboard-sidebar-toggle');

    if (!dashboardPage || !sidebar || !toggleButton) {
        return;
    }

    // Check if mobile device
    const isMobile = window.innerWidth < 1024; // lg breakpoint

    // Mobile sidebar handling
    const handleMobileSidebar = () => {
        const isMobileNow = window.innerWidth < 1024;
        
        if (isMobileNow) {
            // On mobile: sidebar closed by default
            sidebar.classList.remove('dashboard-page__sidebar--collapsed');
            sidebar.classList.remove('dashboard-page__sidebar--mobile-open');
            dashboardPage.classList.remove('dashboard-page--sidebar-collapsed');
            dashboardPage.classList.remove('dashboard-page--sidebar-mobile-open');
            toggleButton.setAttribute('aria-expanded', 'false');
        } else {
            // On desktop: use saved state
            const savedState = localStorage.getItem('dashboard-sidebar-collapsed');
            const isCollapsed = savedState === 'true';
            
            sidebar.classList.remove('dashboard-page__sidebar--mobile-open');
            dashboardPage.classList.remove('dashboard-page--sidebar-mobile-open');
            
            if (isCollapsed) {
                sidebar.classList.add('dashboard-page__sidebar--collapsed');
                dashboardPage.classList.add('dashboard-page--sidebar-collapsed');
                toggleButton.setAttribute('aria-expanded', 'false');
            } else {
                sidebar.classList.remove('dashboard-page__sidebar--collapsed');
                dashboardPage.classList.remove('dashboard-page--sidebar-collapsed');
                toggleButton.setAttribute('aria-expanded', 'true');
            }
        }
    };

    // Set initial state
    handleMobileSidebar();

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleMobileSidebar, 100);
    });

    // Toggle button click handler
    toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const isMobileNow = window.innerWidth < 1024;
        
        if (isMobileNow) {
            // Mobile: toggle mobile-open class
            const isOpen = sidebar.classList.contains('dashboard-page__sidebar--mobile-open');
            
            if (isOpen) {
                // Close sidebar
                sidebar.classList.remove('dashboard-page__sidebar--mobile-open');
                dashboardPage.classList.remove('dashboard-page--sidebar-mobile-open');
                toggleButton.setAttribute('aria-expanded', 'false');
            } else {
                // Open sidebar
                sidebar.classList.add('dashboard-page__sidebar--mobile-open');
                dashboardPage.classList.add('dashboard-page--sidebar-mobile-open');
                toggleButton.setAttribute('aria-expanded', 'true');
            }
        } else {
            // Desktop: toggle collapsed class
            const isCurrentlyCollapsed = sidebar.classList.contains('dashboard-page__sidebar--collapsed');
            
            if (isCurrentlyCollapsed) {
                // Expand menu
                sidebar.classList.remove('dashboard-page__sidebar--collapsed');
                dashboardPage.classList.remove('dashboard-page--sidebar-collapsed');
                toggleButton.setAttribute('aria-expanded', 'true');
                localStorage.setItem('dashboard-sidebar-collapsed', 'false');
            } else {
                // Collapse menu
                sidebar.classList.add('dashboard-page__sidebar--collapsed');
                dashboardPage.classList.add('dashboard-page--sidebar-collapsed');
                toggleButton.setAttribute('aria-expanded', 'false');
                localStorage.setItem('dashboard-sidebar-collapsed', 'true');
            }
        }
    });

    // Close mobile sidebar when clicking on overlay
    dashboardPage.addEventListener('click', (e) => {
        if (window.innerWidth < 1024 && e.target === dashboardPage) {
            const isOpen = sidebar.classList.contains('dashboard-page__sidebar--mobile-open');
            if (isOpen) {
                sidebar.classList.remove('dashboard-page__sidebar--mobile-open');
                dashboardPage.classList.remove('dashboard-page--sidebar-mobile-open');
                toggleButton.setAttribute('aria-expanded', 'false');
            }
        }
    });

    // Notification dropdown functionality - works for both breadcrumbs (desktop) and sidebar (mobile)
    const initNotificationDropdown = (buttonSelector, dropdownSelector, wrapperSelector, badgeSelector, itemSelector, unreadClass, activeClass) => {
        const notificationButton = document.querySelector(buttonSelector);
        const notificationDropdown = document.querySelector(dropdownSelector);
        const notificationWrapper = document.querySelector(wrapperSelector);

        if (!notificationButton || !notificationDropdown || !notificationWrapper) {
            return;
        }

        // Function to update notification badge
        const updateNotificationBadge = () => {
            const badge = notificationButton.querySelector(badgeSelector);
            const unreadItems = notificationDropdown.querySelectorAll(unreadClass);
            const unreadCount = unreadItems.length;

            if (badge) {
                if (unreadCount > 0) {
                    badge.textContent = unreadCount > 99 ? '99+' : unreadCount;
                    badge.style.display = 'flex';
                } else {
                    badge.style.display = 'none';
                }
            }
        };

        // Update badge on page load
        updateNotificationBadge();

        // Hide empty state if there are notification items
        const notificationList = notificationDropdown.querySelector('.dashboard-breadcrumbs__notification-dropdown-list, .dashboard-page__sidebar__notification-dropdown-list');
        const emptyState = notificationDropdown.querySelector('.dashboard-breadcrumbs__notification-dropdown-list--empty, .dashboard-page__sidebar__notification-dropdown-list--empty');
        const notificationItems = notificationList ? notificationList.querySelectorAll(itemSelector) : [];
        
        if (notificationItems.length > 0 && emptyState) {
            emptyState.style.display = 'none';
        }

        // Toggle dropdown on button click
        notificationButton.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = notificationDropdown.classList.contains(activeClass);
            
            if (isOpen) {
                // Close dropdown
                notificationDropdown.classList.remove(activeClass);
                notificationButton.setAttribute('aria-expanded', 'false');
            } else {
                // Open dropdown
                notificationDropdown.classList.add(activeClass);
                notificationButton.setAttribute('aria-expanded', 'true');
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (!notificationWrapper.contains(e.target)) {
                notificationDropdown.classList.remove(activeClass);
                notificationButton.setAttribute('aria-expanded', 'false');
            }
        });

        // Prevent dropdown from closing when clicking inside it
        notificationDropdown.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        // Handle "Mark all as read" button
        const markAllButton = notificationDropdown.querySelector('.dashboard-breadcrumbs__notification-dropdown-mark-all, .dashboard-page__sidebar__notification-dropdown-mark-all');
        if (markAllButton) {
            markAllButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                // Remove unread class from all items
                const unreadItems = notificationDropdown.querySelectorAll(unreadClass);
                unreadItems.forEach(item => {
                    item.classList.remove('dashboard-breadcrumbs__notification-dropdown-item--unread', 'dashboard-page__sidebar__notification-dropdown-item--unread');
                });

                // Update badge
                updateNotificationBadge();

                // TODO: Add AJAX call to mark all as read on server
            });
        }

        // Update badge when clicking on notification items (mark as read)
        const allNotificationItems = notificationDropdown.querySelectorAll(itemSelector);
        allNotificationItems.forEach(item => {
            item.addEventListener('click', () => {
                // Remove unread class when clicked
                item.classList.remove('dashboard-breadcrumbs__notification-dropdown-item--unread', 'dashboard-page__sidebar__notification-dropdown-item--unread');
                updateNotificationBadge();
            });
        });
    };

    // Initialize for breadcrumbs (desktop)
    initNotificationDropdown(
        '.dashboard-breadcrumbs__notification',
        '.dashboard-breadcrumbs__notification-dropdown',
        '.dashboard-breadcrumbs__notification-wrapper',
        '.dashboard-breadcrumbs__notification-badge',
        '.dashboard-breadcrumbs__notification-dropdown-item',
        '.dashboard-breadcrumbs__notification-dropdown-item--unread',
        'dashboard-breadcrumbs__notification-dropdown--active'
    );

    // Initialize for sidebar (mobile)
    initNotificationDropdown(
        '.dashboard-page__sidebar__notification',
        '.dashboard-page__sidebar__notification-dropdown',
        '.dashboard-page__sidebar__notification-wrapper',
        '.dashboard-page__sidebar__notification-badge',
        '.dashboard-page__sidebar__notification-dropdown-item',
        '.dashboard-page__sidebar__notification-dropdown-item--unread',
        'dashboard-page__sidebar__notification-dropdown--active'
    );
});

